import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import AppComponent from '@base/features/app/appComponent';
import { initModules } from '@base/init';
import { container } from 'tsyringe';
import { History } from 'history';
import GameProvider from '@dominos/model/gameProvider';
import DEFAULT_PREFERENCES from '@dominos/constants/defaultPreferences';
import TableRepository from '@dominos/model/tableRepository';
import ImageProvider from '@base/features/image/imageProvider';
import { BASE_PATH, BG_IMAGE_COLLECTION } from '@dominos/constants/imageCollection';

const gameProvider = new GameProvider();
const tableRepository = new TableRepository();
const imageProvider = new ImageProvider(BASE_PATH, BG_IMAGE_COLLECTION);
initModules(gameProvider, tableRepository, imageProvider, DEFAULT_PREFERENCES);

const history: History = container.resolve('history');

ReactDOM.render(
  <div className="App">
    <Router history={history}>
      <AppComponent />
    </Router>
  </div>,
  document.getElementById('root')
);
